import { defineMessages } from 'react-intl';
export default defineMessages({
  suivant: {
    id: 'signup_auth_button.next',
  },
  precedent: {
    id: 'signup_auth_button.previous',
  },
});
